// Khung XEM TRƯỚC nội dung bài Kênh Cộng Đồng — dựng đúng như web/app hiển thị:
// khối (tiêu đề, gạch đầu dòng, danh sách số, kẻ ngang, ảnh chèn giữa bài) +
// inline (đậm/nghiêng/gạch ngang/link/chip mã).
//
// Renderer tham chiếu: frontend/src/pages/Community/community-post-rich-content.js
// và mobile/src/modules/community-channel/components/community-post-content.tsx.
import React from "react";
import { parseContentBlocks } from "./community-content-blocks";
import { renderCommunityRichText } from "./community-rich-text";

/**
 * @param {object} props
 * @param {string} props.text nội dung đang soạn
 * @param {string[]} props.imageUrls URL ảnh của bài theo đúng thứ tự (cho `![N]`)
 */
export default function CommunityContentPreview({ text, imageUrls = [] }) {
    if (!String(text || "").trim()) return null;
    const blocks = parseContentBlocks(text);

    return (
        <div className="mb-4">
            <div className="mb-1.5 text-xs text-content-3">Xem trước (như hiển thị trên web/app)</div>
            <div className="flex flex-col gap-1.5 rounded-lg border border-line bg-surface-sunken px-3 py-2 text-[15px] leading-relaxed text-content">
                {blocks.map((block, idx) => {
                    if (block.type === "divider") return <hr key={idx} className="my-1 border-line" />;
                    if (block.type === "image") {
                        const url = imageUrls[block.imageIndex - 1];
                        return url ? (
                            <img
                                key={idx}
                                src={url}
                                alt=""
                                className="max-h-64 w-auto self-start rounded-lg object-contain"
                            />
                        ) : (
                            <div key={idx} className="rounded border border-dashed border-red-300 px-2 py-1 text-xs text-red-500">
                                Chưa có ảnh thứ {block.imageIndex} — thêm ảnh cho bài hoặc sửa lại vị trí
                            </div>
                        );
                    }
                    if (block.type === "heading") {
                        return (
                            <h3 key={idx} className="text-[17px] font-bold text-content break-words">
                                {renderCommunityRichText(block.text)}
                            </h3>
                        );
                    }
                    if (block.type === "bullet" || block.type === "numbered") {
                        return (
                            <div key={idx} className="flex gap-2">
                                <span className="shrink-0 text-content-3">
                                    {block.type === "bullet" ? "•" : `${block.order}.`}
                                </span>
                                <span className="flex-1 break-words">{renderCommunityRichText(block.text)}</span>
                            </div>
                        );
                    }
                    return (
                        <p key={idx} className="whitespace-pre-wrap break-words">
                            {renderCommunityRichText(block.text)}
                        </p>
                    );
                })}
            </div>
        </div>
    );
}
